import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import notification from './modules/notifiocation'
import image_popup from './modules/image_popup'
import progress_bar from './modules/progress_bar'
import browser from './modules/browser'
import locales from './modules/locales'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    notification,
    image_popup,
    progress_bar,
    browser,
    locales,
  },
})
